<style lang="less" scoped>
.margin-tb {
  height: 32px;
  margin-top: 4px;
}
.title-div {
  font-weight: 600;
  margin: 20px 0;
  font-size: 26px;
  flex-grow: 1;
  color: #000;
  height: 30px;
}
.el-dialog__body {
  padding:10px 40px 40px;
}
.msg_con{
  min-height: 200px;
  width: 50%;
  padding-left: 50px;
  div{
    margin-top: 10px;
  }
  table{
    margin-top: 20px;
    tr{
      th{
      border: 1px solid #eaeaea; 
      background: #FAFAFA;
      color: #8F9BB3;
      }
      td{
      border: 1px solid #eaeaea; 
      color: #8F9BB3;
      }
    }
  }
}
.msg_con:first-of-type{
  padding-right: 50px;
  border-right: 1px solid #eeeff3;
}

</style>

<template>
  <div>
      <div class="title-div">私桩升级</div>
      <!-- 表格 -->
        <ZD-table
          :tableColumns="pageConfig.updateListColumns"
          :operates="operates"
          :tableData="tableData"
          :tableConfig="pageConfig.noSeltableConfig"
          :selections="selections"
          v-on:updateSelections="
            (sels) => {
              selections = sels;
            }
          "
        ></ZD-table>
      <!-- 分页 -->
      <!-- <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
      </div> -->
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      tableData: [
        {
          messageTypeName:'111'
        }
      ], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      showMultiQuerys:false,//高级筛选
      queryInfo: {}, //标签页 搜索字段
      showDialog: true, //弹窗
      dealerVisible: false, //分配运营商弹窗
      selectLabelVisible: false, //选择标签弹窗
      labelName: "11", //	未使用
      labelForm: {}, //标签管理内容
      dealerForm: {}, //分配运营商内容
      checkList: [], //选中标签
      labelsArr: [], //客户标签
      selectLabelForm: {}, //所有标签内容
      labelSum: 0, //合计客户数量 默认0
      operates: {
        width: 220,
        fixed: "right",
        list: [],
      },
      searchTime: [], //注册时间
      firstSearchTime: [], //首次充电时间
      lastSearchTime: [], //最近充电时间
      options: [], //未使用
      value: [], //未使用
      pileList: [], //桩列表
      loading: false, //未使用
      dealNameArr: [], //未使用
      dealerList: [], //未使用
      updateInfo:{
        firstMessageTypeName:'1111',
        errorDesc:'234'
      
      }
      //btnUse: false,
    };
  },
  methods: {
    init() {
      // this.getPileList();
      this.pileCode = this.$store.state.pileObj.pileCode
      this.getListData(this.pagination, true);
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      // _.$H.post(_, _.$A.cust.pagecust, _.queryInfo).then((res) => {
      _.$H.post(_, _.$A.pile.upgradeManager, {pileNo:_.pileCode}).then((res) => {
        _.tableData = res.data.data || [];
        // _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },
    toDetail(row){
      this.updateInfo = row
      this.toDetail = true
    }
  },
  mounted() {
    this.init();
  },
};
</script>
